import SectionHeading from './SectionHeading';
import { longGossip } from '@/mocks/material';

function Progress({ value }: { value: number }) {
  return (
    <div className="flex items-center gap-3">
      <div className="h-1.5 w-full overflow-hidden rounded-full bg-background-200">
        <div
          className="h-full rounded-full bg-accent-500"
          style={{ width: `${value}%` }}
        />
      </div>
      <span className="whitespace-nowrap text-xs font-semibold text-accent-700">{value}% 补齐</span>
    </div>
  );
}

export default function LongGossip() {
  const featured = longGossip[0];
  const rest = longGossip.slice(1);

  return (
    <section id="longgossip" className="mx-auto max-w-[1240px] scroll-mt-24 px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        index="03"
        kicker="翻旧账合集"
        title="剧情太长的瓜，我们帮你铺成一条线"
        desc="跨度多年、来回拉扯的长期瓜，单独翻很容易漏。这里把它们按阶段并册，连线索一起补齐，一条线看到尾。"
        linkText="翻更多旧账"
      />

      {/* 大卡：主推长线 */}
      <article className="group mt-10 grid overflow-hidden rounded-lg border border-background-200 bg-background-50 lg:grid-cols-[0.85fr_1.15fr]">
        <div className="relative h-[300px] overflow-hidden md:h-full">
          <img
            src={featured.image}
            alt={featured.title}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute left-3 top-3 rounded-sm bg-primary-500 px-2 py-1 text-[11px] font-semibold text-background-50">
            主打长线 · {featured.stage} 个阶段
          </span>
        </div>
        <div className="flex flex-col justify-between gap-8 p-6 md:p-9">
          <div>
            <div className="flex flex-wrap items-center gap-3 text-xs">
              <span className="font-heading font-bold text-primary-600">{featured.range}</span>
              {featured.tags.map((t) => (
                <span key={t} className="rounded-sm bg-background-200/80 px-1.5 py-0.5 text-foreground-500">
                  {t}
                </span>
              ))}
            </div>
            <h3 className="font-heading mt-4 text-2xl font-black leading-snug text-foreground-950 md:text-3xl">
              {featured.title}
            </h3>
            <p className="mt-4 max-w-xl text-sm leading-7 text-foreground-600">{featured.excerpt}</p>
          </div>
          <div className="space-y-3">
            <Progress value={featured.progress} />
            <div className="flex flex-col gap-3 pt-2 sm:flex-row">
              <button
                type="button"
                className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                打开整条长线
              </button>
              <button
                type="button"
                className="whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                只看关键节点
              </button>
            </div>
          </div>
        </div>
      </article>

      {/* 两枚较小卡 */}
      <div className="mt-6 grid gap-6 sm:grid-cols-2">
        {rest.map((c) => (
          <article
            key={c.id}
            className="group grid gap-0 overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-200 sm:grid-cols-[0.9fr_1.1fr]"
          >
            <div className="relative h-48 overflow-hidden sm:h-full">
              <img
                src={c.image}
                alt={c.title}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="flex flex-col justify-between gap-5 p-5">
              <div>
                <div className="flex flex-wrap items-center gap-2 text-[11px]">
                  <span className="font-heading font-bold text-primary-600">{c.range}</span>
                  <span className="rounded-sm bg-background-200/80 px-1.5 py-0.5 text-foreground-500">{c.stage} 阶段</span>
                </div>
                <h3 className="font-heading mt-3 text-base font-bold leading-snug text-foreground-950 md:text-lg">
                  {c.title}
                </h3>
                <p className="mt-2 text-xs leading-6 text-foreground-600 md:text-[13px]">{c.excerpt}</p>
              </div>
              <div className="space-y-2">
                <Progress value={c.progress} />
                <button
                  type="button"
                  className="mt-1 inline-flex items-center gap-1.5 text-xs font-semibold text-primary-600 hover:text-primary-700"
                >
                  进合集
                  <i className="ri-arrow-right-line" />
                </button>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}